import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// URL-param feature flags that are promoted to sessionStorage so they survive
// navigation and route redirects that drop the query string (e.g. /create).
// The read side lives in useFeatureFlag.
const PERSISTED_FLAGS = ["DATA_AGENT"];

/**
 * Persists URL-param feature flags to sessionStorage. Mount once at the app
 * root so `?FLAG=true` is captured on any page — a flag set on a page that
 * later redirects (stripping the query string) would otherwise never reach the
 * component that reads it. `?FLAG=false` clears the persisted value.
 */
export const useSyncFeatureFlags = (): void => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    for (const flag of PERSISTED_FLAGS) {
      const value = params.get(flag);
      if (value === "true") {
        sessionStorage.setItem(`flag:${flag}`, "true");
      } else if (value === "false") {
        sessionStorage.removeItem(`flag:${flag}`);
      }
    }
  }, [search]);
};
